import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpiritualStage } from '@core/api/generated/api-client';
import { spiritualStageLabels } from '@core/api/enums/spiritual-stage.labels';

@Component({
  selector: 'app-spiritual-stage-badge',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  templateUrl: './spiritual-stage-badge.component.html',
  styleUrl: './spiritual-stage-badge.component.scss'
})
export class SpiritualStageBadgeComponent {
  @Input() stage?: SpiritualStage | null;

  get label(): string | null {
    if (!this.stage) return null;
    return spiritualStageLabels[this.stage] ?? this.stage;
  }
}
